export default "__VITE_ASSET__B5ZxvrGz__"